<script setup lang="ts">
type PotatoProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<PotatoProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 790.88 675.59"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d" />
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i">
      <path
        class="u"
        :fill="getColor('#efd7a0')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M740.89,353.58c11.41,50.42,22.1,101.02,21.19,151.65-1.23,68.43-42.32,81.32-87.81,123.12-53.95,49.57-93.5,1.62-144.7-33.09-63.15-42.81-131.75-79.95-202.42-106.65-35.34-13.35-72.61-23.96-105.98-42.49-32.78-18.2-59.46-48.19-85.73-74.55-45.66-45.8-72.31-85.81-90.51-148.32-6.37-21.87-22.67-51.7-22.8-73.06-.16-27.52,24.97-33.08,45.57-50.9C133.62,42.27,231.71,20.53,317.68,20.63c187.1,.21,373.57,122.8,423.21,332.96Z"
      />
    </g>
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
